import { useEffect, useState } from "react";
import { getSocket } from 'state/socket';

const useSocket = (userId) => {
  const [onlineUsers, setOnlineUsers] = useState([]);

  useEffect(() => {
    if (!userId) return;
    const socket = getSocket();
    if (!socket) return;

    const handler = (users) => setOnlineUsers(users);
    socket.on("online-users", handler);
    socket.emit("get-online-users");
    return () => socket.off("online-users", handler);
  }, [userId]);

  return { onlineUsers };
};

export default useSocket;
